import clsx from "clsx";
import { useLocale } from "@/i18n";
import { CheckIcon, VehicleTypeIcon } from "@/components/ui/Icons";
import { Notice } from "@/components/Notice";
import type { PublicArrivalTypeOption } from "@/types";

export function ArrivalTypeSelection({
  options,
  value,
  onChange,
  disabled,
}: {
  options: PublicArrivalTypeOption[];
  value: string;
  onChange: (code: string) => void;
  disabled?: boolean;
}) {
  const { messages: m } = useLocale();

  if (options.length === 0) {
    return <Notice variant="warning">{m.arrivalType.noneAvailable}</Notice>;
  }

  return (
    <fieldset className="bk-section" disabled={disabled}>
      <legend className="bk-section-title">{m.arrivalType.legend}</legend>
      <div
        className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:gap-3"
        role="radiogroup"
        aria-label={m.arrivalType.legend}
      >
        {options.map((type) => {
          const selected = value === type.value;
          return (
            <button
              key={type.value}
              type="button"
              role="radio"
              aria-checked={selected}
              disabled={disabled}
              onClick={() => onChange(type.value)}
              className={clsx(
                "bk-tile flex-col items-center gap-2 px-2 py-3.5 text-center sm:flex-row sm:items-center sm:gap-3 sm:px-3.5 sm:text-left",
                selected && "bk-tile--selected",
              )}
            >
              <span className="bk-tile__icon">
                <VehicleTypeIcon code={type.value} className="h-6 w-6" />
              </span>
              <span className="bk-tile__body">
                <span className="bk-tile__title">{type.label}</span>
              </span>
              <span className="bk-tile__check absolute right-2 top-2 sm:static">
                <CheckIcon />
              </span>
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
